<template>
  <div id="app">
    <router-view></router-view>

    <!-- Popups and Modals -->
    <SlideYUpTransition>
      <InviteUserPopup :key="'invite-popup'" />
    </SlideYUpTransition>
    <SlideYUpTransition>
      <CheckEmailPopup :key="'check-email-popup'" />
    </SlideYUpTransition>

    <portal-target name="app">
      <!--
      The slot content of the above portal component will be rendered here.
      -->
    </portal-target>

    <!-- Notifications -->
    <notifications
      :group="'main'"
      :position="'bottom right'"
      :classes="'vue-notification'"
    />
    <notifications
      :group="'studio'"
      :position="'bottom left'"
      :classes="'vue-notification'"
    />
  </div>
</template>

<script>
import InviteUserPopup from "@/components/modals/InviteUsersPopup";
import CheckEmailPopup from "@/components/modals/CheckEmailPopup";
import { SlideYUpTransition } from "vue2-transitions";

export default {
  components: {
    InviteUserPopup,
    CheckEmailPopup,
    SlideYUpTransition,
  },
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  .vue-notification {
    padding: 10px;
    margin: 0 5px 5px;
    font-size: 12px;
    border-radius: 5px;
    color: #ffffff;
    background: #44a4fc;
    border-left: 0;
    z-index: 9999;

    &.warn {
      background: #ffb648;
    }

    &.error {
      background: #e54d42;
    }

    &.success {
      background: #68cd86;
    }
  }
}
</style>
